const bodyLock = () => {
  let body = document.body;
  scrollPosition = window.pageYOffset;
  body.classList.add('lock');
  body.style.top = `-${scrollPosition}px`;
}

global.bodyLock = bodyLock;

const bodyUnlock = () => {
  let body = document.body;
  body.classList.remove('lock');
  body.style.removeProperty('top');
  window.scrollTo(0, scrollPosition);
}

global.bodyUnlock = bodyUnlock;

const sendRequest = async (method, url, body) => {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(body),
  };

  const res = await fetch(url, options);
  if (!res.ok) {
    const errorData = await res.json();
    throw errorData;
  }
  return res.json();
};

global.sendRequest = sendRequest;

const showNotify = ({ status, message }) => {
  const wrapper = document.querySelector('.notify-wrapper');
  if (!wrapper) return;

  const notifyBody = document.createElement('div');
  notifyBody.classList.add('notify-body');
  const notify = document.createElement('div');
  notify.classList.add('notify', status);
  notify.innerHTML = message;

  notifyBody.append(notify);
  wrapper.append(notifyBody);

  setTimeout(() => {
    notifyBody.remove();
  }, 2000);
};

global.showNotify = showNotify;
